import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import { FeatureFlagsContext } from '@core-ui/feature-flags';


const useBRRedesignOpacity = (): boolean => {
  const { abbrBrand } = useContext(BrandInfoContext);
  const { enabledFeatures } = useContext(FeatureFlagsContext);

  return (!!(enabledFeatures['seo-filter-button-opacity']
  && enabledFeatures['seo-br-redesign'])
  && (abbrBrand === 'br' || abbrBrand === 'brfs'));
};

export default useBRRedesignOpacity;
